import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { Flex, Form, Upload, UploadFile } from "antd";

import {
    StyledAPContractTableFile,
    StyledAPContractTableFileIcon,
    StyledAPContractTableFileName,
} from "@/pages/WorkPlan/AboutPoint/Styled";
import { BaseButton } from "@/shared/ui/BaseButton";
import { ContractFormValues } from "@/types/form";
import { getFileUrl } from "@/utils/file/getFileUrl";
import { handleDownloadFile } from "@/utils/file/handleDownloadFile";

import { StyledContainer, StyledDeleteFileButton } from "./Styled";

interface FileUploadSectionProps {
    oldFiles: string[];
    onDeleteFile: (file: string) => void;
}

export const FileUploadSection: React.FC<FileUploadSectionProps> = ({
    oldFiles,
    onDeleteFile,
}) => {
    return (
        <StyledContainer vertical gap={8}>
            <Form.Item<ContractFormValues>
                name="files"
                label="Документи:"
                valuePropName="fileList"
                getValueFromEvent={(e) =>
                    (Array.isArray(e) ? e : e?.fileList) as UploadFile[]
                }
                style={{ margin: 0 }}
            >
                <Upload
                    name="files"
                    beforeUpload={() => false}
                    style={{ width: "100%" }}
                >
                    <BaseButton icon={<UploadOutlined />} type="primary">
                        Завантажити файл
                    </BaseButton>
                </Upload>
            </Form.Item>

            {oldFiles.map((file) => {
                const fileName = file.split("/").pop() || "document";
                return (
                    <StyledAPContractTableFile key={file}>
                        <Flex
                            gap="8px"
                            align="center"
                            justify="space-between"
                            style={{ width: "100%" }}
                        >
                            <Flex gap="8px" align="center">
                                <StyledAPContractTableFileIcon />
                                <StyledAPContractTableFileName
                                    onClick={() =>
                                        handleDownloadFile(
                                            getFileUrl(file),
                                            fileName.split(".")[0],
                                        )
                                    }
                                >
                                    {fileName}
                                </StyledAPContractTableFileName>
                            </Flex>

                            <StyledDeleteFileButton
                                type="text"
                                onClick={() => onDeleteFile(file)}
                                icon={<DeleteOutlined />}
                            />
                        </Flex>
                    </StyledAPContractTableFile>
                );
            })}
        </StyledContainer>
    );
};
